import {withStyle} from 'baseui';
import {Spinner} from 'baseui/spinner';
export const ExtraLargeSpinner = withStyle(Spinner, {
    width: '100px',
    height: '100px',
    borderLeftWidth: '12px',
    borderRightWidth: '12px',
    borderTopWidth: '12px',
    borderBottomWidth: '12px',
  });